import React from 'react';
import { useSelector } from 'react-redux';
import CustomLink from '../../UI/CustomLink';
import IconCreditCard from '../../UI/Icons/IconCreditCard';
import IconStar from '../../UI/Icons/IconStar';
import IconList from '../../UI/Icons/IconList';
import IconMessage from '../../UI/Icons/IconMessage';
import IconUser from '../../UI/Icons/IconUser';
import helpers from '../../../helpers/helpers';

const CabinetHeaderMobile = () => {
  const { getTranslationText } = helpers;

  const { token } = useSelector((state) => state.auth);

  return token ? (
    <div className="cabinet-header__mobile">
      <CustomLink
        href="/cabinet/balance"
        as="/cabinet/balance"
      >
        <IconCreditCard color="#A19EA8" />
        <span>{getTranslationText('header.profile_balance')}</span>
      </CustomLink>
      <CustomLink
        href="/cabinet/gallery"
        as="/cabinet/gallery"
      >
        <IconStar color="#A19EA8" />
        <span>{getTranslationText('header.profile_gallery')}</span>
      </CustomLink>
      <CustomLink
        href="/cabinet/deals"
        as="/cabinet/deals"
      >
        <IconList color="#A19EA8" />
        <span>{getTranslationText('header.profile_deals')}</span>
      </CustomLink>
      <CustomLink
        href="/cabinet/support"
        as="/cabinet/support"
      >
        <IconMessage color="#A19EA8" />
        <span>{getTranslationText('header.profile_support')}</span>
      </CustomLink>
      <CustomLink
        href="/cabinet/profile"
        as="/cabinet/profile"
      >
        <IconUser color="#A19EA8" />
        <span>{getTranslationText('header.profile_profile')}</span>
      </CustomLink>
    </div>
  ) : null;
};

export default CabinetHeaderMobile;
